import React, { useEffect, useState } from 'react'
import { Breadcrumbs, Crumb } from '@/components/ui/breadcrumb'
import { TransactionDto } from 'api/Transaction/Types/Transaction'
import { links } from 'utils/featureToggles'

import { TransactionDetailsView } from '../ResolveTransactionDetailsRoute'
import TransactionDetailsAdjustmentWalletAndPaymentAgentPage from '../TransactionDetailsAdjustmentWalletAndPaymentAgent/TransactionDetailsAdjustmentWalletAndPaymentAgentPage'

interface Props {
  data: TransactionDto
  forceRefresh(): void
}

function getTransactionDetailsWalletCrumbs(
  type:
    | TransactionDetailsView.WalletTransfer
    | TransactionDetailsView.DepositFromPaymentAgent
    | TransactionDetailsView.WithdrawToPaymentAgent
    | TransactionDetailsView.ManualAdjustment
    | TransactionDetailsView.MIBCommission
    | TransactionDetailsView.Reverse
    | TransactionDetailsView.IBCommission
    | TransactionDetailsView.IBMultiTier
    | TransactionDetailsView.IBCashback
    | TransactionDetailsView.NegativeEquityRefund
    | TransactionDetailsView.ZuluTradePerformanceFee
    | TransactionDetailsView.ZuluTradeSubscriptionFee
    | TransactionDetailsView.ManualTradingAccountAdjustment
    | TransactionDetailsView.SocialTradingCampaign
    | TransactionDetailsView.CopyTraderFeesTA
    | TransactionDetailsView.IBCashbackAdjustment
    | TransactionDetailsView.CampaignBonus
    | TransactionDetailsView.PelicanMonthlyFee
    | TransactionDetailsView.PelicanPerformanceFee
    | TransactionDetailsView.CopyTraderFees
    | TransactionDetailsView.SubscriptionFee
    | TransactionDetailsView.PerpetualsFunding
    | TransactionDetailsView.LoyaltyRewardPayout
    | TransactionDetailsView.DividendAdjustment
    | TransactionDetailsView.MonthlyInterestTransfer
): Crumb[] {
  switch (type) {
    case TransactionDetailsView.WalletTransfer:
      return [{ title: 'Transactions - Wallet', link: links.transactionWallet.url }]
    case TransactionDetailsView.DepositFromPaymentAgent:
      return [{ title: 'Transactions - Payment Agent', link: links.transactionPaymentAgent.url }]
    case TransactionDetailsView.WithdrawToPaymentAgent:
      return [{ title: 'Transactions - Payment Agent', link: links.transactionPaymentAgent.url }]
    case TransactionDetailsView.ManualAdjustment:
    case TransactionDetailsView.CopyTraderFees:
      return [
        {
          title: 'Transactions - Wallet Adjustments',
          link: links.transactionWalletAdjustments.url,
        },
      ]
    case TransactionDetailsView.IBCommission:
    case TransactionDetailsView.IBMultiTier:
    case TransactionDetailsView.MIBCommission:
      return [{ title: 'Transactions - IB Commissions', link: links.transactionIBCommissions.url }]
    case TransactionDetailsView.Reverse:
      return [{ title: 'Transactions - Wallet', link: links.transactionWallet.url }]
    case TransactionDetailsView.IBCashback:
    case TransactionDetailsView.IBCashbackAdjustment:
      return [{ title: 'Transactions - IB Cashback', link: links.transactionIBCashBacks.url }]
    case TransactionDetailsView.NegativeEquityRefund:
    case TransactionDetailsView.ZuluTradePerformanceFee:
    case TransactionDetailsView.ZuluTradeSubscriptionFee:
    case TransactionDetailsView.ManualTradingAccountAdjustment:
    case TransactionDetailsView.SocialTradingCampaign:
    case TransactionDetailsView.CopyTraderFeesTA:
    case TransactionDetailsView.CampaignBonus:
    case TransactionDetailsView.PelicanMonthlyFee:
    case TransactionDetailsView.PelicanPerformanceFee:
    case TransactionDetailsView.SubscriptionFee:
    case TransactionDetailsView.PerpetualsFunding:
    case TransactionDetailsView.DividendAdjustment:
    case TransactionDetailsView.MonthlyInterestTransfer:
      return [
        {
          title: 'Transactions - Trading Account Adjustments',
          link: links.transactionTradingAccountAdjustments.url,
        },
      ]
    default:
      return [{ title: 'Transactions - Wallet', link: links.transactionWallet.url }]
  }
}

const TransactionDetailsAdjustmentWalletPage: React.FC<Props> = (props) => {
  const [crumbs, setCrumbs] = useState(getTransactionDetailsWalletCrumbs(props.data.type.id))

  useEffect(() => {
    const [crumb1, crumb2] = [
      ...crumbs,
      {
        title: props.data.referenceId,
        link: '/transactions/' + props.data.id,
      },
    ]
    setCrumbs([crumb1, crumb2])
  }, [props.data]) // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <React.Fragment>
      <Breadcrumbs crumbs={crumbs} />
      <TransactionDetailsAdjustmentWalletAndPaymentAgentPage {...props} />
    </React.Fragment>
  )
}

export default TransactionDetailsAdjustmentWalletPage
